const setRVURL = (serverURL) => {
  const apiBeacon = (url, data) => {
    const fullURL = `${serverURL}${url}`;
    const json = JSON.stringify(data);
    if (navigator.sendBeacon) {
      if (navigator.sendBeacon(fullURL, json)) {
        return true;
      }
    }
    fetch(fullURL, {
      method: "POST",
      credentials: "include",
      body: json,
    });
  };

  const collectText = (elt, callback) => {
    const children = elt.childNodes;
    const n = children.length;
    if (n) {
      for (let i = 0; i < n; ++i) {
        collectText(children[i], callback);
      }
    } else if (elt.nodeType === Node.TEXT_NODE) {
      callback(elt.nodeValue);
    } else if (elt.tagName === "IMG") {
      callback(elt.alt);
    }
  };

  const readText = (elt) => {
    let s = "";
    collectText(elt, (x) => {
      if (x) s += x;
    });
    return s;
  };

  const beaconClickHandler = (evt) => {
    let elt = evt.target;
    for (; elt; elt = elt.parentNode) {
      const tag = elt.tagName;
      if (tag === "BUTTON" || tag === "A") {
        break;
      }
    }
    if (!elt) return;
    const params = {};
    if (elt.tagName === "A") {
      params.type = "LINK";
      params.href = elt.href;
    } else if (elt.tagName === "BUTTON") {
      params.type = "BUTTON";
    } else {
      throw new Error("assertion failure");
    }
    params.text = readText(elt);
    apiBeacon("/event", params);
  };

  // https://stackoverflow.com/a/4588211
  function fullPath(el) {
    var names = [];
    while (el.parentNode) {
      if (el.id) {
        names.unshift("#" + el.id);
        break;
      } else {
        if (el === el.ownerDocument.documentElement) names.unshift(el.tagName);
        else {
          for (
            var c = 1, e = el;
            e.previousElementSibling;
            e = e.previousElementSibling, c++
          );
          names.unshift(el.tagName + ":nth-child(" + c + ")");
        }
        el = el.parentNode;
      }
    }
    return names.join(" > ");
  }

  const beaconErrorHandler = (evt) => {
    const error = evt.error;
    apiBeacon("/event", {
      type: "ERROR",
      error: String(error),
      ...(error && error.stack && { stack: error.stack }),
      ...(evt.target && { target: fullPath(evt.target) }),
    });
  };

  const beaconVideoHandler = (evt) => {
    apiBeacon("/event", {
      type: "VIDEO",
      event: evt.type,
      ...(evt.target && {
        target: fullPath(evt.target),
        currentTime: evt.target.currentTime,
      }),
    });
  };

  if (navigator.sendBeacon) {
    apiBeacon("/counter", { referrer: document.referrer });
  } else {
    new Image().src = `${serverURL}/spacer.png`;
  }

  window.addEventListener("click", beaconClickHandler, true);
  window.addEventListener("error", beaconErrorHandler, true);
  window.addEventListener("play", beaconVideoHandler, true);
  window.addEventListener("pause", beaconVideoHandler, true);
  window.addEventListener("ended", beaconVideoHandler, true);

  (async () => {
    try {
      const re1 = location.href.match(/^(.*\/)page\/\d+\/$/);
      if (!re1) return;
      const url1 = re1[1];
      const resp1 = await fetch(url1);
      if (!resp1.ok) return;
      const text1 = await resp1.text();
      const doc1 = document.implementation.createHTMLDocument();
      doc1.write(text1);
      const metas = new Set();
      for (const meta of document.querySelectorAll("meta")) {
        metas.add(meta.outerHTML);
      }
      const ar = [];
      for (const meta of doc1.querySelectorAll("meta")) {
        const sig = meta.outerHTML;
        if (!metas.has(sig)) {
          metas.add(sig);
          ar.push(meta);
        }
      }
      for (const meta of ar) {
        document.head.append(meta);
      }
    } catch (e) {
      // never mind
    }
  })();
};
